import React from 'react';
import { AppLayout } from '@/components/AppLayout';
import { ResumeRevisionsWizard } from '@/components/ResumeRevisionsWizard/ResumeRevisionsWizard';
import { RevisionSession } from '@/types/resumeRevision';
import { useToast } from '@/components/ui/use-toast';

const ResumeRevisions: React.FC = () => {
  const { toast } = useToast();

  const handleComplete = (session: RevisionSession) => {
    toast({
      title: "Revision Complete",
      description: `Successfully completed revision session: ${session.session_name}`,
    });
    
    // Could redirect to a results page or resume library
    console.log('Completed session:', session);
  };

  const handleCancel = () => {
    // Navigate back or show confirmation
    window.history.back();
  };

  return (
    <AppLayout>
      <ResumeRevisionsWizard 
        onComplete={handleComplete}
        onCancel={handleCancel}
      />
    </AppLayout>
  );
};

export default ResumeRevisions;